/**
 * Created by jv on 24/04/2018.
 */
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");

// Styles
require("Styles/pages/marketing/faq.scss");

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();

  FaqPage.init();
});

let FaqPage = {};

((FaqPage) => {
  FaqPage.init = function () {
    setUpFaqCollapse();
  };

  function setUpFaqCollapse() {
    let $faqTriggers = $(".section-faq .faq-trigger");
    let $faqCollapseContent = $(".section-faq .faq-item .collapse");

    $faqTriggers.off("click").on("click", (e) => {
      $(e.currentTarget).parent().next().collapse("toggle");
    });

    $faqCollapseContent.off("show.bs.collapse").on("show.bs.collapse", (e) => {
      $(e.currentTarget).parent().addClass("faq-collapse__show");
    });

    $faqCollapseContent.off("hide.bs.collapse").on("hide.bs.collapse", (e) => {
      $(e.currentTarget).parent().removeClass("faq-collapse__show");
    });
  }

})(FaqPage);



// WEBPACK FOOTER //
// ./app/js/entries/marketing/faq.js